import { Link } from 'react-router-dom';
import { generateAuthUrl } from './client';
import { Container, Row, Col, FormGroup } from 'react-bootstrap';
import { getEnv } from '../../getEnv';
import PortalLogo from '../../assets/portalLogo';
import Button from 'react-bootstrap/Button';
import Footer from './footer';
import { isAuthenticated } from './sessionStore';
import { logger } from '../../lib/logger';

export const SignIn = () => {
  const authenticated = isAuthenticated();
  const env = getEnv();

  const login = async () => {
    try {
      const domain = env.keycloak_realm || '';

      const authUrl = await generateAuthUrl({
        kc_idp_hint:  env.keycloak_idp_hint || domain,
        redirect_uri: env.oauth_redirect_uri,
      });

      window.location.assign(authUrl);
    } catch (err) {
      logger.error('Login failed');
    }
  };

  return (
    <Container fluid className="signin" data-testid="login">
      <Row>
        <Col>
          <Row className="py-5">
            <Col className="text-center">
              <PortalLogo className="login-logo mx-auto" />

              {authenticated &&
                <div>
                  <p>You&#39;re already signed in.</p>
                  <p>Do you want to <Link to={'/signout'}>sign out?</Link></p>
                </div>
              }

              {!authenticated &&
                <FormGroup>
                  <Button data-testid="button-signin" type="submit" className="px-5" onClick={login}>Sign In</Button>
                </FormGroup>
              }
            </Col>
          </Row>
          <Footer />
        </Col>
      </Row>
    </Container>
  );
};
